<avi-dashboard-widget
    class="cloud-widget"
    shape="internet-of-things"
    status="success"
    [iconSize]="24"
    headerText="{{ l10nKeys.cloudServicesHeader | vtranslate }}"
    [showFooter]="showFooterButtons"
>
    <div
        dashboardWidgetBody
        class="cloud-widget__body"
    >
        <h6 class="cloud-widget__label"> {{ l10nKeys.clusterNameLabel | vtranslate }} </h6>
        <div class="cloud-widget__value sel-portal-url"> {{ controllerName ?? '-' }} </div>

        <div
            class="cloud-widget__value-container"
            *ngrxLet="portalUrl$ as portalUrl"
        >
            <h6 class="cloud-widget__label"> {{ l10nKeys.portalUrlLabel | vtranslate }} </h6>
            <div class="cloud-widget__value sel-portal-url"> {{ portalUrl ?? '-' }} </div>
        </div>

        <div
            class="cloud-widget__value-container"
            *ngrxLet="siteId$ as siteId"
        >
            <h6 class="cloud-widget__label"> {{ l10nKeys.siteIdLabel | vtranslate }} </h6>
            <div class="cloud-widget__value sel-portal-url"> {{ siteId }} </div>
        </div>
    </div>

    <div
        dashboardWidgetFooter
        class="cloud-widget__footer"
    >
        <ng-container *ngIf="deregisterLoading; else deregisterLoadingLoaded">
            <div class="cloud-widget__status-spinner">
                <clr-spinner clrSmall></clr-spinner>
            </div>
        </ng-container>
        <ng-template #deregisterLoadingLoaded>
            <cds-button
                (click)="connectAndRegisterController()"
                (keydown.enter)="connectAndRegisterController()"
                [disabled]="!isAdminTenant"
                *ngIf="isUnregisteredAndDisconnected"
                action="flat"
                class="cloud-widget__button"
                size="sm"
                status="info"
            >
                {{ l10nKeys.connectToCloudServiceLabel | vtranslate }}
            </cds-button>
            <cds-button
                (click)="deregisterController()"
                (keydown.enter)="deregisterController()"
                [disabled]="!isAdminTenant"
                *ngIf="isControllerRegistered"
                action="flat"
                class="cloud-widget__button"
                size="sm"
                status="danger"
            >
                {{ l10nKeys.disconnectFromCloudServiceLabel | vtranslate }}
            </cds-button>
            <div
                class="cloud-widget__button-group"
                *ngIf="isUnregisteredAndConnected"
            >
                <cds-button
                    (click)="openRegistrationModal()"
                    (keydown.enter)="openRegistrationModal()"
                    [disabled]="!isAdminTenant"
                    action="solid"
                    class="cloud-widget__button"
                    size="sm"
                    status="info"
                >
                    {{ l10nKeys.controllerRegisteredControllerBtnLabel | vtranslate }}
                </cds-button>
                <cds-button
                    (click)="handleCancelRegistration()"
                    (keydown.enter)="handleCancelRegistration()"
                    [disabled]="!isAdminTenant"
                    action="flat"
                    class="cloud-widget__button"
                    size="sm"
                    status="info"
                >
                    {{ globalL10nKeys.cancelLabel | vtranslate }}
                </cds-button>
            </div>
        </ng-template>
    </div>
</avi-dashboard-widget>
